export default "__VITE_ASSET__Bw8D0Hvm__"